<template>
  <div v-if="ir !== null">
    <!-- Default Messaging -->
    <h3>Default Messaging</h3>
    <div class="py-5">顯示於Investor Relations頁面</div>
    <div>
      <!-- Investor Relations -->
      <div class="form-item d-flex py-5">
        <div class="w-174px mr-6">
          <h4>Investor Relations</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">
          <div class="link-decoration-none" v-html="ir.investor_relations"></div>
        </div>
      </div>
      <!-- Transfer Agent -->
      <div class="form-item d-flex py-5">
        <div class="w-174px mr-6">
          <h4>Transfer Agent</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 ">
          <div class="link-decoration-none" v-html="ir.transfer_agent"></div>
        </div>
      </div>
      <!-- Banner -->
      <div class="form-item py-5 d-flex">
        <div class="w-174px mr-6">
          <h4>Picture</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="w-305px h-187px bg-cover bg-center ml-auto"
            :style="{
              'background-image': `url(${ir.default_messaging_pic||defaultBanner})`,
              'border-radius': '8px',
            }"
          ></div>
        </div>
      </div>
    </div>

    <!-- Quick Link -->
    <h3 class="mt-5">Quick Link</h3>
    <div class="py-5">可編輯文字及連結，可擴充</div>
    <div>
      <div v-for="(item, i) in ir.quick_links" :key="i">
        <!-- label -->
        <div class="form-item d-flex py-5">
          <h4 class="w-180px">Label {{ i + 1 }}</h4>
          <div class="flex-grow-1 flex-basis-0">
            {{ item.title }}
          </div>
        </div>
        <!-- url -->
        <div class="form-item d-flex py-5">
          <div class="w-180px"><h4>URL</h4></div>
          <div class="flex-grow-1 flex-basis-0">
            <a :href="item.url" class="text-decoration-none">{{ item.url }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ir: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    defaultBanner: 'https://dummyimage.com/305x187.jpg',
  }),
};
</script>

<style></style>
